export default "__VITE_ASSET__DKUa_Ysi__"